// @ts-expect-error [TS migration] Was not detected by flow
import React, { useMemo, Node } from 'react';
import { useTranslation } from 'react-i18next';
import Selector from 'components/inputs/Selector';
import NumericInput from 'components/inputs/NumericInput';
import Typography from '@mui/material/Typography';
import {
    TimeScales as TS,
    SlidingTimeScales,
    DynamicFilterOperations as DFO,
} from 'business/definitions';

type Props = {
    filter: SentenceFilterT;
    setFilter: FlowAnyFunction;
    children: Node;
    isDisabled?: boolean;
};
function DynamicDatePicker({
    children,
    filter,
    setFilter,
    isDisabled,
}: Props): Node {
    const { t } = useTranslation();

    const optionValues = useMemo(() => {
        const baseScales = Object.values(TS).filter(
            (scale) => scale !== TS.dow,
        );
        const slidingScales =
            filter.operation === DFO.last
                ? Object.values(SlidingTimeScales)
                : [];
        return [...baseScales, ...slidingScales];
    }, [filter.operation]);

    const options = useMemo(
        () =>
            optionValues.map((scale) => ({
                label: t(`sentence:${scale}`),
                value: scale,
            })),
        [optionValues],
    );
    if (filter.value === '1' || filter.operation === 'is_null') return children;
    return (
        <>
            <Typography style={{ marginRight: '6px' }}>
                {t('sentence:filterLinker.inThe')}
            </Typography>
            <NumericInput
                inputName="value"
                disabled={isDisabled}
                value={filter.value}
                // @ts-expect-error [TS migration] Was not detected by flow
                onChange={(value) => setFilter({ value })}
            />
            {children}

            <Selector
                disabled={isDisabled}
                options={options}
                value={filter.valueScale}
                onChange={(valueScale) => setFilter({ valueScale })}
                fullWidth={false}
            />
        </>
    );
}
export default DynamicDatePicker;
